<template>
  <section>
    <b-card title="">
      <b-row
        xl="12"
        sm="12"
      >
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <b-input-group>
            <flat-pickr
              v-model="date_start"
              class="form-control"
              :config="config"
              placeholder="DD-MM-YYYY"
              @input="(date) => changeDate(date, 'date_start')"
            />
            <b-input-group-append is-text>
              <feather-icon
                icon="CalendarIcon"
                class="cursor-pointer"
              />
              <b>&nbsp;Start</b>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <b-input-group>
            <flat-pickr
              v-model="date_finish"
              class="form-control"
              :config="config"
              placeholder="DD-MM-YYYY"
              @input="(date) => changeDate(date, 'date_finish')"
            />
            <b-input-group-append is-text>
              <feather-icon
                icon="ClockIcon"
                class="cursor-pointer"
              />
              <b>&nbsp;Finish</b>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <!--MHD-->
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <v-select
            v-model="select_type"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="reportMHDOption"
            :reduce="(reportMHDOption) => reportMHDOption.value"
            label="title"
            placeholder="M/H/D"
            class="w-100"
          />
        </b-col>
        <b-col>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            class="sidebar-center"
            variant="outline-primary"
            @click="filterz()"
          >
            <feather-icon icon="SearchIcon" /> Filter
          </b-button>
        </b-col>
        <!--MHD-->
      </b-row>
    </b-card>
    <b-card-code
      title=""
      no-body
    >
      <b-card>
        <div>
          <b-dropdown
            id="dropdown-1"
            text="Export"
            class="mb-1"
            variant="primary"
          >
            <b-dropdown-item><b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              class="ml-1 mb-1"
              variant="outline-primary"
              @click="exportExcel"
            >
              <feather-icon icon="DownloadIcon" /> Export Excel
            </b-button></b-dropdown-item>

            <b-dropdown-item><b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              class="ml-1 mb-1"
              variant="outline-primary"
              @click="exportWord"
            >
              <feather-icon icon="DownloadIcon" /> Export Word
            </b-button></b-dropdown-item>
          </b-dropdown>
        </div>
        <div>
          <div class="h-50 d-inline-block" />
        </div>
        <div class="d-none justify-content-between flex-wrap">
          <!-- sorting  -->
          <b-form-group
            label="Sort"
            label-size="sm"
            label-align-sm="left"
            label-cols-sm="3"
            label-for="sortBySelect"
            class="ml-1"
          >
            <b-input-group size="sm">
              <b-form-select
                id="sortBySelect"
                v-model="sortBy"
                :options="sortOptions"
              >
                <template #first>
                  <option value="">
                    none
                  </option>
                </template>
              </b-form-select>
              <b-form-select
                v-model="sortDesc"
                size="sm"
                :disabled="!sortBy"
              >
                <option :value="false">
                  Asc
                </option>
                <option :value="true">
                  Desc
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>

          <!-- filter -->
          <b-form-group
            label="Filter"
            label-cols-sm="3"
            label-align-sm="left"
            label-size="sm"
            label-for="filterInput"
            class="mr-1"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              />
              <b-input-group-append>
                <b-button
                  :disabled="!filter"
                  @click="filter = ''"
                >
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <b-table
          :key="key"
          striped
          hover
          responsive
          class="position-relative"
          :items="items"
          :fields="fields"
          @sort-changed="sortChanged"
        >
          <template #cell(action)="row">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item>
                  <b-link :to="{ path: '/project-temperature.inventory/detail/' + row.item.id }">
                    <feather-icon
                      icon="Edit2Icon"
                      class="mr-50"
                    />
                    <span>Edit</span>
                  </b-link>
                </b-dropdown-item>
                <b-dropdown-item>
                  <b-link
                    v-b-modal.modal-center
                    @click="rowOnDelete(row.item.id)"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      class="mr-50"
                    />
                    <span>Delete</span>
                  </b-link>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </template>
        </b-table>
        <b-card-body>
          <Pagination
            :current-page.sync="currentPage"
            :per-page.sync="perPage"
            :total-rows="totalRows"
            @filter="handleFilter"
          />
        </b-card-body>
      </b-card>
    </b-card-code>
  </section>
</template>
<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BTable, BCol, BCard, BRow, BFormGroup, BFormSelect, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import XLSX from 'xlsx'
import {
  Document,
  HeadingLevel,
  ImageRun,
  Packer,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  VerticalAlign,
  TextRun,
  AlignmentType,
  Header,
  Footer,
} from 'docx'
import Pagination from '@/views/general/components/Pagination.vue'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    flatPickr, BCardCode, vSelect, BTable, BCol, BCard, BRow, BFormGroup, BFormSelect, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem, Pagination,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      date_start: moment(String(new Date())).format('YYYY-MM-DD'),
      date_finish: moment(String(new Date())).format('YYYY-MM-DD'),
      config: {
        enableTime: false,
        time_24hr: false,
      },
      dir: false,
      perPage: 10,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      select_type: 'M',
      filter: null,
      filterOn: [],
      key: 0,
      params: {
        date_start: '',
        date_finish: '',
        type_report: '',
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      status: [{
        AC: 'Active', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        AC: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      reportMHDOption: [
        { title: 'Minutes', value: 'M' },
        { title: 'Hours', value: 'H' },
        { title: 'Days', value: 'D' },
      ],
    }
  },
  computed: {
    ...mapState({
      totalRows: state => state.temperature.reportMHD.totalRows,
      fields: state => state.temperature.reportMHD.fields,
      items: state => state.temperature.reportMHD.items,
      fullItems: state => state.temperature.reportMHD.fullItems,
      pageOptions: state => state.temperature.reportMHD.pageOptions,
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    dateFormat() {
      // eslint-disable-next-line camelcase
      return create_at => this.$options.filters.formatDate(create_at)
    },
  },
  mounted() {
    // Set the initial number of items
    this.$store.state.totalRows = this.items.length
  },
  created() {
    const dateStart = moment(this.date_start, 'YYYY-MM-DD')
    const dateFinish = dateStart.clone().add(23, 'hours').add(59, 'minutes')
    this.params = {
      date_start: dateStart.utc().toISOString(),
      date_finish: dateFinish.utc().toISOString(),
      type_report: 'M',
      page: this.currentPage,
      limit: this.perPage,
      search: this.filter,
    }
    this.$store.dispatch('temperature/getReportMHD', this.params)
  },
  methods: {
    handleFilter(currentPage, perPage) {
      this.currentPage = currentPage
      this.perPage = perPage
      this.filterz()
    },
    sortChanged({ sortBy, sortDesc, sortDirection }) {
      this.sortBy = sortBy
      this.sortDesc = sortDesc
      this.sortDirection = sortDirection
      this.filterz()
    },
    changeDate(selectedDate, field) {
      console.log(`Selected date for ${field}:`, selectedDate)
      this[field] = selectedDate

      // Return the updated params object
      return {
        [field]: this[field],
      }
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.totalRows = filteredItems.length
      this.currentPage = 1
    },
    advanceSearch(val) {
      this.searchTerm = val
    },
    rowOnDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete everything.', {
          title: 'Please Confirm', size: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'No', cancelVariant: 'outline-secondary', hideHeaderClose: false, centered: true,
        })
        .then(value => {
          if (value === true) {
            this.$store.dispatch('temperature.inventory', id)
              .then(response => {
                if (response.status === 200) {
                  this.$store.dispatch('temperature/getInventory')
                  this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
                } else {
                  this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
                }
              },
              () => {
                this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
              })
          }
        })
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
    async exportWord() {
      // Wait for getFullData to finish updating fullItems before proceeding
      await this.getFullData()
      useJwt.getProfile().then(response => {
        const project = response.data.data.user_projects[0].projects.name
        const companyName = response.data.data.companies.name || 'PT. _________'
        const { fullItems } = this

        fullItems.sort((a, b) => new Date(a.date_time) - new Date(b.date_time))

        const groupedItems = this.groupItemsByDate(fullItems)

        const doc = new Document({
          sections: [

          ],
        })

        Object.keys(groupedItems).forEach(date => {
          if (Object.prototype.hasOwnProperty.call(groupedItems, date)) {
            const rows = this.createRows(groupedItems[date])
            const table = this.createTable(rows)

            doc.addSection({
              properties: {},
              footers: {
                default: new Footer({
                  children: [
                    new Paragraph({
                      children: [
                        new ImageRun({
                          data: fetch('https://ik.imagekit.io/ftti7xeyu/MDS/Screenshot%202024-03-07%20162102.png?updatedAt=1709803300078')
                            .then(imgResponse => {
                              if (!imgResponse.ok) {
                                throw new Error('Network response was not ok')
                              }
                              return imgResponse.arrayBuffer()
                            })
                            .catch(error => {
                              console.error('Error fetching image:', error)
                            }),
                          transformation: {
                            width: 200,
                            height: 50,
                          },
                        }),
                      ],
                    }),
                  ],
                }),
              },
              headers: {
                default: new Header({
                  children: [
                    new Paragraph({
                      children: [
                        new ImageRun({
                          data: fetch('https://ik.imagekit.io/ftti7xeyu/MDS/Logo.png?updatedAt=1704766240189')
                            .then(imgResponse => {
                              if (!imgResponse.ok) {
                                throw new Error('Network response was not ok')
                              }
                              return imgResponse.arrayBuffer()
                            })
                            .catch(error => {
                              console.error('Error fetching image:', error)
                            }),
                          transformation: {
                            width: 192,
                            height: 85,
                          },
                        }),
                      ],
                    }),
                  ],
                }),
              },
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: `Data ${project}`,
                      bold: true,
                      color: '000000',
                      size: 28,
                    }),
                  ],
                  heading: HeadingLevel.HEADING_1,
                  alignment: AlignmentType.CENTER,
                }),
                new Paragraph({
                  children: [
                    new TextRun({
                      text: companyName,
                      bold: true,
                      color: '000000',
                      size: 28,
                    }),
                  ],
                  heading: HeadingLevel.HEADING_1,
                  alignment: AlignmentType.CENTER,
                }),
                new Paragraph({
                  children: [
                    new TextRun({
                      text: ` ${this.params.date_start} sd. ${this.params.date_finish}`,
                      color: 'ffffff',
                      size: 24,
                    }),
                  ],
                  heading: HeadingLevel.HEADING_1,
                }),
                new Paragraph({
                  children: [
                    new TextRun({
                      text: `Periode: ${date.replace(/,/g, '')}`,
                      color: '000000',
                      size: 24,
                    }),
                  ],
                  heading: HeadingLevel.HEADING_1,
                }),
                table,
              ],
            })
          }
        })

        this.exportDoc(doc, `Data_${project}.docx`)
      })
    },

    exportDoc(doc, filename) {
      Packer.toBuffer(doc).then(buffer => {
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        console.log(`${filename} exported successfully`)
      }).catch(error => {
        console.error(`Error exporting ${filename}:`, error)
      })
    },
    groupItemsByDate() {
      const groupedItems = {}
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.fullItems.length; i++) {
        const date = this.fullItems[i].date_time.split(' ')[0]
        if (!groupedItems[date]) {
          groupedItems[date] = []
        }
        groupedItems[date].push(this.fullItems[i])
      }
      return groupedItems
    },
    createRows(items) {
      const rows = []
      // Create a new array with stringified properties to avoid mutating the parameter
      const processedItems = items.map(item => ({
        ...item,
        date_time: item.date_time.toString(),
        ph: item.ph.toString(),
        nh3: item.nh3.toString(),
        cod: item.cod.toString(),
        tss: item.tss.toString(),
        debit: item.debit.toString(),
      }))
      // eslint-disable-next-line no-plusplus
      for (let y = 0; y < processedItems.length; y++) {
        const {
          date_time, ph, nh3, cod, tss, debit,
        } = processedItems[y]

        const baseCells = [
          // eslint-disable-next-line camelcase
          date_time, ph, nh3, cod, tss, debit,
        ].map(text => new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.CENTER,
              children: [new TextRun({ text, color: '000000', size: 24 })],
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
        }))

        const row = new TableRow({
          children: [...baseCells],
          verticalAlign: VerticalAlign.CENTER,
        })

        rows.push(row)
      }
      return rows
    },
    createTable(rows) {
      const baseHeaders = [
        { text: 'Date', underline: '_____________________________' },
        { text: 'PH', underline: '_____________' },
        { text: 'NH3N', underline: '_____________' },
        { text: 'COD', underline: '_____________' },
        { text: 'TSS', underline: '_____________' },
        { text: 'Debit', underline: '_____________' },
      ]

      const headerCells = [...baseHeaders].map(h => new TableCell({
        children: [
          new Paragraph({
            alignment: AlignmentType.CENTER,
            children: [
              new TextRun({ text: h.text, color: '000000', size: 24 }),
              new TextRun({ text: h.underline, color: 'ffffff' }),
            ],
          }),
        ],
        verticalAlign: VerticalAlign.CENTER,
      }))

      return new Table({
        rows: [
          new TableRow({
            children: headerCells,
            verticalAlign: VerticalAlign.CENTER,
          }),
          ...rows,
        ],
      })
    },
    async exportExcel() {
      await this.getFullData()
      let nameProject = ''
      useJwt.getProfile().then(response => {
        nameProject = response.data.data.user_projects[0].projects.name
        const jsons = []
        // eslint-disable-next-line no-plusplus
        for (let y = 0; y < this.fullItems.length; y++) {
          jsons[y] = {
            Project: nameProject,
            Date: this.fullItems[y].date_time,
            Ph: this.fullItems[y].ph,
            Nh3: this.fullItems[y].nh3,
            Cod: this.fullItems[y].cod,
            Tss: this.fullItems[y].tss,
            Debit: this.fullItems[y].debit,
          }
        }
        const dataJson = XLSX.utils.json_to_sheet(jsons)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataJson, 'data')
        XLSX.writeFile(wb, `${nameProject}_Report_data_${moment(this.date_start).format('DD-MM-YYYY')}_${moment(this.date_finish).format('DD-MM-YYYY')}.xlsx`)
      })
    },
    getFullData() {
      return new Promise((resolve, reject) => {
        const dateStartUTC = moment(this.date_start, 'YYYY-MM-DD').utc().toISOString()
        const dateFinishUTC = moment(this.date_finish, 'YYYY-MM-DD').add(23, 'hours').add(59, 'minutes').utc()
          .toISOString()
        const orderBy = this.sortBy ? JSON.stringify({ [this.sortBy]: this.sortDesc ? 'desc' : 'asc' }) : ''
        // Update this.params based on the provided fields
        this.params = {
          date_start: dateStartUTC,
          date_finish: dateFinishUTC,
          type_report: this.select_type,
        }

        if (orderBy) {
          this.params.orderBy = orderBy
        }

        // Dispatch action with updated params
        this.$store.dispatch('temperature/getReportFullData', this.params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    filterz() {
      // Use changeDate to update date_start and date_finish fields
      this.changeDate(this.date_start, 'date_start')
      this.changeDate(this.date_finish, 'date_finish')

      const dateStartUTC = moment(this.date_start, 'YYYY-MM-DD').utc().toISOString()
      const dateFinishUTC = moment(this.date_finish, 'YYYY-MM-DD').add(23, 'hours').add(59, 'minutes').utc()
        .toISOString()

      const start = moment(this.date_start)
      const end = moment(this.date_finish)

      const diffInDays = end.diff(start, 'days')

      if (diffInDays > 31) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Warning',
            icon: 'AlertCircleIcon',
            variant: 'error',
            text: 'The selected range cannot exceed 31 days.',
          },
        })
        return
      }

      const orderBy = this.sortBy ? JSON.stringify({ [this.sortBy]: this.sortDesc ? 'desc' : 'asc' }) : ''

      // Update this.params based on the provided fields
      this.params = {
        date_start: dateStartUTC,
        date_finish: dateFinishUTC,
        type_report: this.select_type,
        page: this.currentPage,
        limit: this.perPage,
        search: this.filter,
      }

      if (orderBy) {
        this.params.orderBy = orderBy
      }

      // Dispatch action with updated params
      this.$store.dispatch('temperature/getReportMHD', this.params)
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
